<template>
  <section>
    <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="p20-scrollbar__view">
      <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      <el-date-picker type="datetime" placeholder="结束日期" v-model="filters.endTime"
        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      <el-button type="primary" @click="getXHAccessChartDay">查询</el-button>
      <div class="content-title">日产量柱状图</div>
      <ve-line :data="chartData" :extend="extend" :settings="chartSettings" :mark-point="lineChartMarkPoint"></ve-line>

    </el-scrollbar>
  </section>
</template>

<script>
import * as api from "../../api/command";
import util from "../../../util/date";
export default {
  name: "AdminDashboard",
  data() {
    return {
      filters: {
        startTime: '',
        endTime: ''
      },
      chartData: {
        columns: [],
        rows: []
      },
      chartSettings: {
        yAxisName: ['m³']
      },
      lineChartMarkPoint: {
        data: [
          {
            name: "最大值",
            type: "max",
          },
          {
            name: "最小值",
            type: "min",
          },
        ],
      },
      extend: {
        series: {
          type: 'bar',
          label: {
            normal: {
              show: false,
            },
          },
        },
      },
    };
  },
  created() { },
  methods: {
    getXHAccessChartDay() {
      var currentDate = new Date();
      if (!this.filters.startTime) {
      
        // 减去7天
        this.filters.startTime = util.formatDate.format(currentDate, "yyyy-MM-dd 00:00:00");
      }
      if (!this.filters.endTime) {

        this.filters.endTime = util.formatDate.format(currentDate, "yyyy-MM-dd 23:59:59");;
      }
      let para = this.filters;
      api.getXHAccessChartDay(para).then((res) => {
        let rows = [];

        this.chartData = res.data;
      });
    }
  },
  mounted() {
    this.getXHAccessChartDay();
  },
};
</script>

<style scoped>
.content-title {
  clear: both;
  font-weight: 400;
  line-height: 50px;
  padding: 10px 10px;
  font-size: 22px;
  color: #1f2f3d;
}
</style>
